import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import HotelCard from './components/HotelCard';

import { MAX_WIDTH } from '../constants';
import type { WidgetSettingsFormValues } from '../../context/constructorContext/types';
import { useConstructorContextState } from '../../context/constructorContext';
import { useGetHotelData } from './hooks';

interface IHotelWidget {
  initialState: Partial<WidgetSettingsFormValues>;
}

const HotelWidget = (props: IHotelWidget): JSX.Element | null => {
  const initialState = { ...props.initialState, ...useConstructorContextState() };
  const getHotelData = useGetHotelData();
  const [hotelData, setHotelData] = useState<Record<string, any>>();

  useEffect(() => {
    if (!getHotelData || !initialState) {
      return;
    }

    (async () => {
      const data = await getHotelData(initialState.searchParams?.hotel_id);
      setHotelData(data);
    })();
  }, []);

  if (!hotelData) {
    return null;
  }

  return (
    <StyledHotelWidgetContainer>
      <HotelCard initialState={{ ...initialState, hotelData }} />
    </StyledHotelWidgetContainer>
  );
};

const StyledHotelWidgetContainer = styled.div`
  width: 100%;
  max-width: ${MAX_WIDTH}px;
  margin: auto;
  overflow: hidden;

  background: #fff;
  color: #17181a;

  @media (min-width: 476px) {
    border-radius: 4px;
    box-shadow: rgb(216 214 204 / 90%) 0px 10px 15px 0px, rgb(210 208 197 / 90%) 0px 1px 2px 0px;
  }
`;

export default HotelWidget;
